import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const DropdownSelect = ({ label, id, options, handleChange, selected }) => {
  const onChange = (e) => {
    handleChange(_.find(options, o => o.value === e.target.value), id);
  }
  return (
    <div className="dropdown-select-native">
      <label htmlFor={id}>{label}</label>
      <select id={id} onChange={onChange} value={selected}>
        {options.map(o => <option value={o.value} key={o.label}>{o.label}</option>)}
      </select>
    </div>
  );
};

DropdownSelect.propTypes = {
  label: PropTypes.string.isRequired,
  selected: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
};

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/components/shared/dropdown-select/dropdown-select.js